module.exports = __webpack_public_path__ + "img/hr-tree-02-a-trunk.0c75a0a6.png";